"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@ikea-aoa/utilities");
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var IowsAuthenticationService_1 = __importDefault(require("../../services/authentication/iows/IowsAuthenticationService"));
var OneWebAuthenticationService_1 = __importDefault(require("../../services/authentication/one-web/OneWebAuthenticationService"));
var NifAuthenticationService_1 = __importDefault(require("../../services/authentication/nif/NifAuthenticationService"));
var ChinaAuthenticationService_1 = __importDefault(require("../../services/authentication/china/ChinaAuthenticationService"));
/**
 * This class is used for storing items in a queue.
 */
var AuthenticationQueue = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param cache CacheStore.
     */
    function AuthenticationQueue(cache) {
        this.cache = null;
        this.cache = cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Creates user authentication.
     *
     * @param options Options.
     * @param options.consumer Consumer.
     * @param options.contract Contract.
     * @param options.endpoint IOWS authentication endpoint.
     * @returns Promise object.
     */
    AuthenticationQueue.prototype.getAuthenticationIows = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, cacheStore, queuedPromises, promiseQueue, authService, authentication, _i, promiseQueue_1, promise, error_1, _a, promiseQueue_2, promise;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = 'iowsAuthenticationQueue';
                        cacheStore = this.cache.getStore(CacheStoreType_1.default.authentication);
                        queuedPromises = cacheStore.get(cacheKey);
                        if (queuedPromises) {
                            return [2 /*return*/, new Promise(function (resolve, reject) { return queuedPromises.push({ resolve: resolve, reject: reject }); })];
                        }
                        promiseQueue = [];
                        authService = new IowsAuthenticationService_1.default(options);
                        cacheStore.set(cacheKey, promiseQueue);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, authService.getUser()];
                    case 2:
                        authentication = _b.sent();
                        for (_i = 0, promiseQueue_1 = promiseQueue; _i < promiseQueue_1.length; _i++) {
                            promise = promiseQueue_1[_i];
                            promise.resolve(authentication);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        for (_a = 0, promiseQueue_2 = promiseQueue; _a < promiseQueue_2.length; _a++) {
                            promise = promiseQueue_2[_a];
                            promise.reject(error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        cacheStore.delete(cacheKey);
                        return [2 /*return*/, authentication];
                }
            });
        });
    };
    /**
     * Gets or creates user token.
     *
     * @param options Options.
     * @param options.endpoint OneWeb authentication endpoint.
     * @returns Promise object.
     */
    AuthenticationQueue.prototype.getAuthTokenOneWeb = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, cacheStore, queuedPromises, promiseQueue, authService, authentication, _i, promiseQueue_3, promise, error_2, _a, promiseQueue_4, promise;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = 'oneWebAuthenticationQueue';
                        cacheStore = this.cache.getStore(CacheStoreType_1.default.authentication);
                        queuedPromises = cacheStore.get(cacheKey);
                        if (queuedPromises) {
                            return [2 /*return*/, new Promise(function (resolve, reject) { return queuedPromises.push({ resolve: resolve, reject: reject }); })];
                        }
                        promiseQueue = [];
                        authService = new OneWebAuthenticationService_1.default(options);
                        cacheStore.set(cacheKey, promiseQueue);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, authService.getToken()];
                    case 2:
                        authentication = _b.sent();
                        for (_i = 0, promiseQueue_3 = promiseQueue; _i < promiseQueue_3.length; _i++) {
                            promise = promiseQueue_3[_i];
                            promise.resolve(authentication);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        for (_a = 0, promiseQueue_4 = promiseQueue; _a < promiseQueue_4.length; _a++) {
                            promise = promiseQueue_4[_a];
                            promise.reject(error_2);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        cacheStore.delete(cacheKey);
                        return [2 /*return*/, authentication];
                }
            });
        });
    };
    /**
     * Gets or creates user token.
     *
     * @param options Options.
     * @param options.refreshTokenEndpoint Refresh token endpoint.
     * @param options.loginPageEndpoint Login endpoint.
     * @param options.login Force login. If omitted trye fetch existing token.
     * @returns Promise object.
     */
    AuthenticationQueue.prototype.getAuthTokenChina = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, cacheStore, queuedPromises, promiseQueue, authService, authentication, _i, promiseQueue_5, promise, error_3, _a, promiseQueue_6, promise;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = 'chinaAuthenticationQueue';
                        cacheStore = this.cache.getStore(CacheStoreType_1.default.authentication);
                        queuedPromises = cacheStore.get(cacheKey);
                        if (queuedPromises) {
                            return [2 /*return*/, new Promise(function (resolve, reject) { return queuedPromises.push({ resolve: resolve, reject: reject }); })];
                        }
                        promiseQueue = [];
                        authService = new ChinaAuthenticationService_1.default({
                            refreshTokenEndpoint: options.refreshTokenEndpoint,
                            loginPageEndpoint: options.loginPageEndpoint
                        });
                        cacheStore.set(cacheKey, promiseQueue);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (options.login ? authService.login() : authService.getToken())];
                    case 2:
                        authentication = _b.sent();
                        for (_i = 0, promiseQueue_5 = promiseQueue; _i < promiseQueue_5.length; _i++) {
                            promise = promiseQueue_5[_i];
                            promise.resolve(authentication);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        for (_a = 0, promiseQueue_6 = promiseQueue; _a < promiseQueue_6.length; _a++) {
                            promise = promiseQueue_6[_a];
                            promise.reject(error_3);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        cacheStore.delete(cacheKey);
                        return [2 /*return*/, authentication];
                }
            });
        });
    };
    /**
     * Creates user authentication.
     *
     * @param options Options.
     * @param options.endpoint Nif authentication endpoint.
     * @returns Promise object.
     */
    AuthenticationQueue.prototype.authenticateNif = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, cacheStore, queuedPromises, promiseQueue, authService, authentication, _i, promiseQueue_7, promise, error_4, _a, promiseQueue_8, promise;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = 'nifAuthenticationQueue';
                        cacheStore = this.cache.getStore(CacheStoreType_1.default.authentication);
                        queuedPromises = cacheStore.get(cacheKey);
                        if (queuedPromises) {
                            return [2 /*return*/, new Promise(function (resolve, reject) { return queuedPromises.push({ resolve: resolve, reject: reject }); })];
                        }
                        promiseQueue = [];
                        authService = new NifAuthenticationService_1.default(options);
                        cacheStore.set(cacheKey, promiseQueue);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, authService.authenticate()];
                    case 2:
                        authentication = _b.sent();
                        for (_i = 0, promiseQueue_7 = promiseQueue; _i < promiseQueue_7.length; _i++) {
                            promise = promiseQueue_7[_i];
                            promise.resolve(authentication);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _b.sent();
                        for (_a = 0, promiseQueue_8 = promiseQueue; _a < promiseQueue_8.length; _a++) {
                            promise = promiseQueue_8[_a];
                            promise.reject(error_4);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        cacheStore.delete(cacheKey);
                        return [2 /*return*/, authentication];
                }
            });
        });
    };
    return AuthenticationQueue;
}());
exports.default = AuthenticationQueue;
//# sourceMappingURL=AuthenticationQueue.js.map